/**
 * Maps the project privacy boolean into its corresponding Segment event enum.
 *
 * @param isPrivate - A boolean indicating if the project is private.
 * @returns A string representing the Segment event enum corresponding to the project's visibility.
 */
export function getProjectVisibilityEnum(isPrivate: boolean) {
  return isPrivate ? 'InviteOnly' : 'Internal';
}
